// extracted by mini-css-extract-plugin
module.exports = {"separator":"ShadowSeparator_separator__Bt5yY"};